// extracted by mini-css-extract-plugin
export default {"menuIcon":"menu-icon-module--menuIcon--nELhG"};